import { DashboardStore } from "./../../../../../dashboard.store";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { JobsStore } from "./../../jobs.store";
import { Job } from "./../../job.model";
import { JobsService } from "./../../jobs.service";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  TemplateRef,
  inject,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { DragulaService, DragulaModule } from "ng2-dragula";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { TagAddComponent } from "src/app/dashboard/main/common/tags/tag-add/tag-add.component";
import { JobsListViewComponent } from "../../job-list-view/job-list-view.component";
import moment from "moment";

import { BulkChangeOwnershipModalComponent } from "../bulk-actions/bulk-change-ownership-modal.component";
import { BulkEditTagsModalComponent } from "../bulk-actions/bulk-edit-tags-modal.component";
import { ActiveClientsOnlyPipe } from "../../../../common/active-clients-only.pipe";
import { JobContentComponent } from "../../job-content/job-content.component";
import { JobsAndTasksCardComponent } from "../../jobs-and-tasks-card/jobs-and-tasks-card.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { FormsModule } from "@angular/forms";
import { TagAddComponent as TagAddComponent_1 } from "../../../../common/tags/tag-add/tag-add.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TagComponent } from "../../../../common/tags/tag.component";
import { BsDropdownDirective, BsDropdownModule } from "ngx-bootstrap/dropdown";

import { NgClass } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DatePickerModule } from "primeng/datepicker";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";
import { BulkChangeStatusComponent } from "../bulk-actions/bulk-change-status.component";
import { ROLE_ADMIN, ROLE_MANAGER, UserPermissions } from "src/app/services/authorization/authorization.models";

@Component({
  selector: "app-jobs-dashboard",
  templateUrl: "./jobs-dashboard.component.html",
  styleUrls: ["./jobs-dashboard.component.scss"],
  imports: [
    NgClass,
    BsDropdownModule,
    TagComponent,
    TooltipModule,
    TagAddComponent_1,
    FormsModule,
    TypeaheadModule,
    DragulaModule,
    JobsAndTasksCardComponent,
    JobsListViewComponent,
    JobContentComponent,
    ActiveClientsOnlyPipe,
    DatePickerModule,
    DropdownModule,
    CheckboxModule,
  ],
})
export class JobsDashboardComponent implements OnInit, AfterViewInit {
  readonly ROLE_ADMIN = ROLE_ADMIN;
  readonly ROLE_MANAGER = ROLE_MANAGER;
  userPermissions: UserPermissions;

  @Output() exportExcelEvent = new EventEmitter<void>();
  @Output() exportPdfEvent = new EventEmitter<void>();
  @Output() exportCsvEvent = new EventEmitter<void>();

  openModal = false;
  data: any;
  job: Job = <Job>{};

  duplicateSelectedObj: any = null;

  jobs = {
    planned: <Array<Job>>[],
    on_hold: <Array<Job>>[],
    in_progress: <Array<Job>>[],
    completed: <Array<Job>>[],
  };
  job_tags_filter = [];
  workspace_tags_filter = [];

  dashboardName = "jobsDashboard";
  isCompletedFilterSelected = false;

  initialFilters = {
    [this.dashboardName]: {
      personFilter: { label: "Me", value: "me" },
      dateFilter: { label: "Not Completed", value: "not_completed" },
      clientFilter: { label: "All clients", value: null },
      selectedCompletedFilter: { label: "All", value: "all" },
      dueDateFilter: { label: "All due dates", value: "all" },
      sortField: "due_date",
      sortOrder: -1,
      isCompletedFilterSelected: false,
    },
  };

  customDueDate;

  andOrWorkspaces = "or";
  andOrJobs = "or";

  selectedJobs: any[] = [];

  cols = [{ field: "name", header: "Name" }];
  selectedDisplayType = "column";

  @ViewChild("workspaceFilterTagList") workspaceFilterTagList: TagAddComponent;
  @ViewChild("jobFilterTagList") jobFilterTagList: TagAddComponent;

  @ViewChild("jobListView") jobListView: JobsListViewComponent;
  @ViewChild("dropdownRef", { static: false }) dropdownRef: BsDropdownDirective;

  @ViewChild("searchInput") searchInput: ElementRef;
  filterText: string = "";
  filteredClients: any[] = [];

  tracks = [
    { id: "planned", title: "Planned", css_name: "planned" },
    { id: "in_progress", title: "In Progress", css_name: "in-progress" },
    { id: "on_hold", title: "On Hold", css_name: "waiting" },
    { id: "completed", title: "Completed", css_name: "completed" },
  ];

  readonly destroyRef = inject(DestroyRef);

  constructor(
    private jobsService: JobsService,
    public jobsStore: JobsStore,
    private localStorage: LocalStorageService,
    private dragulaService: DragulaService,
    public dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public dashboardStore: DashboardStore,
  ) {}

  ngOnInit(): void {
    this.data = this.localStorage.get("data");
    this.userPermissions = this.localStorage.get("userPermissions");
    this.cdr.detectChanges();
    if (!this.dashboardService.filters()[this.dashboardName]) {
      this.dashboardService.filters.update((prevState = {}) => ({
        ...prevState,
        ...this.initialFilters,
      }));
    }

    this.dragulaService
      .dropModel("PROGRESS_TRACKS")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        ({
          name,
          el,
          target,
          source,
          item,
          sourceModel,
          targetModel,
          sourceIndex,
          targetIndex,
        }) => {
          item.status = this.getStatusCodeByName(target.id);
          this.jobsService.saveJob(item).then((res) => {});
        },
      );

    this.jobsStore.notifyJobDeleted
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((job_uuid) => {
        Object.keys(this.jobs).forEach((key) => {
          this.jobs[key] = this.jobs[key].filter((j) => {
            return j.uuid !== job_uuid;
          });
        });

        this.openModal = false;
        this.job = null;
      });

    this.job_tags_filter = this.localStorage.get("job_tags_filter") || [];
    this.workspace_tags_filter =
      this.localStorage.get("workspace_tags_filter") || [];

    this.andOrJobs = this.localStorage.get("and_or_jobs") || "or";
    this.jobFilterTagList.andOrFilter = this.andOrJobs;

    this.andOrWorkspaces = this.localStorage.get("and_or_workspaces") || "or";
    this.workspaceFilterTagList.andOrFilter = this.andOrWorkspaces;

    this.changeDisplayType(
      this.localStorage.get("selectedDisplayType") ?? "column",
    );

    this.jobsService.setSelectedJobOnDashboard
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((job: any) => {
        this.selectJob(job, "");
      });

    this.jobsService.jobsSelectionArray
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((selectedJobs: any[]) => {
        this.selectedJobs = selectedJobs;
      });

    this.dashboardStore.all_clients$.subscribe((clients) => {
      if (clients?.length) {
        this.filteredClients = [...clients];
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewInit(): void {
    console.log(
      "🚀 =>  file: job-list-view.component.ts:118 AFTER VIEW =>  this.dashboardService.filters()[this.dashboardName]:",
      this.dashboardService.filters()[this.dashboardName],
    );
  }

  retrieveJobs(type: string) {
    if (document.getElementById(type) != null) {
      this.jobs[type] = [];
      document.getElementById(type).classList.add("component-loading");
    }

    const {
      [this.dashboardName]: {
        personFilter: { value: personFilter },
        dateFilter: { value: dateFilter },
        clientFilter: { value: clientFilter },
        selectedCompletedFilter: { value: selectedCompletedFilter },
        dueDateFilter: { value: dueDateFilter },
      },
    } = this.dashboardService.filters();

    this.jobsService
      .getJobs(
        personFilter,
        type,
        this.job_tags_filter,
        this.workspace_tags_filter,
        this.andOrWorkspaces,
        this.andOrJobs,
        clientFilter,
      )
      .subscribe((res) => {
        this.jobs[type] = <Array<Job>>res[type];
        if (document.getElementById(type) != null) {
          document.getElementById(type).classList.remove("component-loading"); // remove loading
        }
      });
  }

  retrieveAllJobs() {
    if (this.selectedDisplayType == "column") {
      this.retrieveJobs("planned");
      this.retrieveJobs("on_hold");
      this.retrieveJobs("in_progress");
      this.retrieveJobs("completed");
    } else {
      this.cdr.detectChanges();
      // this.jobListView.dt.reset();
    }
  }

  async selectJob(job: Job, column: string) {
    this.openModal = true;

    this.jobsService.setSelectedJob.next(job.uuid);

    const _job = await this.jobsService.getJob(job.uuid);
    this.job = _job;
  }

  changePersonFilter(filter) {
    console.log("changeFilter", filter);
    let value = filter;
    let label =
      typeof filter == "string"
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : filter.full_name;
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        personFilter: { label, value },
      },
    }));
    // this.dashboardService.show_loading.next(true);
    this.retrieveAllJobs();
  }

  changeSelectedFilter(filter = null) {
    let value = filter;
    let label;
    if (value == "all" || !filter) {
      label = "All";
    }

    if (value == "completed_7_days") {
      label = "Completed in last 7 days";
    }

    if (value == "completed_30_days") {
      label = "Completed in last 30 days";
    }

    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        selectedCompletedFilter: { label, value },
      },
    }));
    if (filter) {
      this.retrieveAllJobs();
    }
  }

  changeTimeFilter(filter) {
    let value = filter;
    let label = filter;
    let isCompletedFilterSelected;
    if (filter == "all") {
      label = "All";
    }

    if (filter == "not_completed") {
      label = "Not Completed";
    }

    if (filter == "overdue") {
      label = "Overdue";
    }

    if (filter == "urgent") {
      label = "Urgent";
    }

    if (filter == "completed") {
      label = "Completed";
      isCompletedFilterSelected = true;
      this.resetDueDateFilter();
    } else {
      isCompletedFilterSelected = false;
      this.changeSelectedFilter();
    }

    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        dateFilter: { label, value },
        isCompletedFilterSelected,
      },
    }));

    this.retrieveAllJobs();
  }

  changeDueDateFilter(filter) {
    let value = filter;
    let label;
    if (value == "all") {
      label = "All due dates";
    }

    if (value == "this_week") {
      label = "Due This week";
    }

    if (value == "this_month") {
      label = "Due This month";
    }

    if (value == "today") {
      label = "Due Today";
    }

    if (value == "overdue") {
      label = "Overdue";
    }

    if (value == "custom") {
      label = `${this.customDueDate[0].replace(
        /\./g,
        "-",
      )}  to  ${this.customDueDate[1].replace(/\./g, "-")}`;
      value = this.customDueDate;
    }

    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        dueDateFilter: { label, value },
      },
    }));

    this.customDueDate = "";
    this.retrieveAllJobs();
  }

  changeClientFilter(change: string | { id: number; name: string }): void {
    let label;
    let value;
    if (typeof change === "string") {
      label = "All Clients";
      value = null;
    } else {
      label = change.name;
      value = change.id;
    }
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        clientFilter: { label, value },
      },
    }));
    this.retrieveAllJobs();
  }

  resetDueDateFilter() {
    let label = "This week";
    let value = "this_week";
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        dueDateFilter: { label, value },
      },
    }));
  }

  getStatusCodeByName(name: string) {
    switch (name) {
      case "planned":
        return 0;
      case "on_hold":
        return 2;
      case "in_progress":
        return 1;
      case "completed":
        return 3;
    }
  }

  openNewJobModal(template: TemplateRef<any>): void {
    this.bsModalRef = this.modalService.show(template, {
      class: "duplicate-job-modal modal-sm",
    });
  }

  selectClient(event) {
    this.duplicateSelectedObj = event.item;
    console.log(event.item);
  }

  addNewJob() {
    this.bsModalRef.hide();
    this.jobsStore.jobs[this.jobsStore.activeTab].forEach((j) => {
      j["selected"] = false;
    });

    delete this.duplicateSelectedObj["_sub"];

    let newJob = new Job({
      client_company: this.duplicateSelectedObj,
      task_groups: [],
      recurrence_options: {
        adjust_start_date: 0,
        weekly_weeks: 0,
        monthly_day: 0,
      },
      target_start_date: moment(new Date()),
      due_date: moment(new Date(), "MM-DD-YYYY"),
    });

    newJob.assigned_to = this.localStorage.get("user");
    newJob["selected"] = true;

    this.job = newJob;
    this.openModal = true;
  }

  addTagToFilter(tag, type) {
    // this was a simple array.push before
    // but was changed to spread syntax to trigger change detection correctly
    if (type == "job") {
      this.job_tags_filter = [...this.job_tags_filter, tag];
      this.jobFilterTagList.addedTags = this.job_tags_filter;
    } else {
      this.workspace_tags_filter = [...this.workspace_tags_filter, tag];
      this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;
    }

    this.localStorage.set("job_tags_filter", this.job_tags_filter);
    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.retrieveAllJobs();
  }

  removeTagFromFilter(tag, type) {
    if (type == "job") {
      this.jobFilterTagList.tags.push(tag);
      this.job_tags_filter = this.job_tags_filter.filter((t) => {
        return t.uuid !== tag.uuid;
      });
      this.jobFilterTagList.addedTags = this.job_tags_filter;
    } else {
      this.workspaceFilterTagList.tags.push(tag);
      this.workspace_tags_filter = this.workspace_tags_filter.filter((t) => {
        return t.uuid !== tag.uuid;
      });
      this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;
    }

    this.localStorage.set("job_tags_filter", this.job_tags_filter);
    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.localStorage.set("and_or_jobs", this.andOrJobs);
    this.localStorage.set("and_or_workspaces", this.andOrWorkspaces);
    this.retrieveAllJobs();
  }

  clearFilter(type) {
    if (type == "job") {
      this.jobFilterTagList.tags = this.jobFilterTagList.all_tags;
      this.job_tags_filter = [];
    } else {
      this.workspaceFilterTagList.tags = this.workspaceFilterTagList.all_tags;
      this.workspace_tags_filter = [];
    }

    this.localStorage.set("job_tags_filter", this.job_tags_filter);
    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.retrieveAllJobs();
  }

  changeDisplayType(type) {
    this.selectedDisplayType = type;

    if (type == "column") {
      this.retrieveAllJobs();
    }

    if (type == "list") {
    }

    this.localStorage.set("selectedDisplayType", this.selectedDisplayType);
  }

  getCompletedFilter() {
    const { isCompletedFilterSelected } =
      this.dashboardService.filters()[this.dashboardName];
    return isCompletedFilterSelected;
  }

  getDueDateFilter() {
    const {
      dueDateFilter: { value },
    } = this.dashboardService.filters()[this.dashboardName];
    const dueDateFilter = this.getCompletedFilter() ? null : value;
    return dueDateFilter;
  }

  closeJobContent() {
    this.jobsService.jobContentClosed.next({});
    this.openModal = false;
    this.changeDisplayType(this.selectedDisplayType);
  }

  changeAndOrFilterWorkspaces(andOr) {
    this.andOrWorkspaces = andOr;
    this.localStorage.set("and_or_workspaces", this.andOrWorkspaces);
    this.retrieveAllJobs();
  }

  changeAndOrFilterJobs(andOr) {
    this.andOrJobs = andOr;
    this.localStorage.set("and_or_jobs", this.andOrJobs);
    this.retrieveAllJobs();
  }

  bulkChangeOwnership() {
    let initialState = {
      jobs: this.selectedJobs,
      accountants: this.jobsStore.company.accountants,
      isFromDashboard: true,
    };
    let changeOwnershipModal = this.modalService.show(
      BulkChangeOwnershipModalComponent,
      { initialState },
    );
    changeOwnershipModal.content.onClose.subscribe(() => {});
  }

  private bulkEditTags(action: "add" | "remove") {
    let initialState = {
      action,
      jobs: this.selectedJobs,
      tags: this.workspace_tags_filter,
    };
    let editTagsModal = this.modalService.show(BulkEditTagsModalComponent, {
      initialState,
    });
    editTagsModal.content.onClose.subscribe(() => {});
  }

  bulkAddTags() {
    this.bulkEditTags("add");
  }
  bulkRemoveTags() {
    this.bulkEditTags("remove");
  }

  onDateSelected() {
    if (this.customDueDate.every((value) => !!value)) {
      this.dropdownRef?.hide();
      this.changeDueDateFilter("custom");
    }
  }

  bulkUpdateStatus() {
    const statuses = [
      { value: 0, label: "Not Started" },
      { value: 1, label: "In Progress" },
      { value: 2, label: "On Hold" },
      { value: 3, label: "Completed" },
    ];
    const initialState = {
      jobs: this.selectedJobs,
      statuses,
    };
    const bulkChangeStatusComponent = this.modalService.show(
      BulkChangeStatusComponent,
      { initialState },
    );
    bulkChangeStatusComponent.content.onClose.subscribe(() => {});
  }

  filterClients() {
    if (!this.filterText?.trim()) {
      this.filteredClients = [...this.dashboardStore.all_clients];
    } else {
      const searchText = this.filterText.toLowerCase().trim();
      this.filteredClients = this.dashboardStore.all_clients.filter((client) =>
        client.name?.toLowerCase().includes(searchText),
      );
    }
    this.cdr.detectChanges();
  }

  clearSearch() {
    this.filterText = "";
    this.filterClients();
  }

  onDropdownShown(): void {
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    });
  }

  triggerExportExcel() {
    this.exportExcelEvent.emit();
  }

  triggerExportPdf() {
    this.exportPdfEvent.emit();
  }

  triggerExportCsv() {
    this.exportCsvEvent.emit();
  }
}
